import {components, SingleValueProps} from 'react-select'
import React from 'react'
import {CustomFieldSelectComponentCustomProps} from 'module/CustomField/component/input/CustomFieldSelectComponent'
import {css} from '@emotion/react'

const cssFixMobileEvents = css`
	font-size: small;
	pointer-events: none;
`

/**
 * fixes mobile issues when openening
 */
export function ReactSelectSingleValue<T>({children, ...props}: SingleValueProps<T, false> & { selectProps: CustomFieldSelectComponentCustomProps }) {
	if (props.selectProps.isFocused) {
		return null;
	} else {
		// pointer-events: none prevents loosing focus on mobile devices when clicking
		return <components.SingleValue {...props} css={cssFixMobileEvents} className={props.className}>
			{children}
		</components.SingleValue>
	}
}